module.exports = {"420105002":"建桥街道","420105004":"晴川街道","420105005":"鹦鹉街道","420105006":"洲头街道","420105007":"五里墩街道","420105008":"琴断口街道","420105009":"江汉二桥街道","420105010":"永丰街道","420105011":"江堤街道","420105012":"四新街道","420105013":"龙阳街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420105.json
// module id = 1824
// module chunks = 0